import updatePreview from '../api/updatePreview'

export default function updateSheet() {
    return (dispatch, getState) => {
        const {selected, sheetData, uid} = getState().sheet

        const header = sheetData[selected].header

        updatePreview(uid, selected, header).then(data => {
            dispatch({
                type: 'UPDATE_SHEET',
                sheetIndex: selected,
                sheet: data
            })
        }).catch(err => {
            err.response.json().then(({error}) => {
                console.error('Error updating sheet:', error)

                dispatch({
                    type: 'UPDATE_SHEET_ERROR',
                    updateErrorMessage: error
                })
            })
        })
    }
}
